import ComputedTransactionApi from "@/services/api_config/ComputedTransactionApi";

export default {
  getCardRegistered(body) {
    return ComputedTransactionApi().post("sold-register/card-registered", body);
  },
  getCardSold(body) {
    return ComputedTransactionApi().post("sold-register/card-sold", body);
  },
};
